export const onlyUnique = (value, index, self) => self.indexOf(value) === index;

export const onlyUniqueObjectOfArray = (array, keyObject) =>
  array.filter((value, index) => {
    return array.findIndex((object) => object[keyObject] === value[keyObject]) === index;
  });
